import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';

import {PaymentType} from '../../../../enums/payment-type.enum';

@Component({
  selector: 'terra-unit-payment-type-modal',
  templateUrl: './unit-payment-type-modal.component.html',
  styleUrls: ['./unit-payment-type-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UnitPaymentTypeModalComponent implements OnInit {
  CrePaymentType = PaymentType;

  constructor(public dialogRef: MatDialogRef<UnitPaymentTypeModalComponent>) {
  }

  ngOnInit(): void {
  }

  /**
   * Closes the modal and returns paymentType
   * @param paymentType Selected payment type
   */
  createPayment(paymentType: PaymentType): void {
    this.dialogRef.close(paymentType);
  }
}
